
import React from 'react';
import { InsightCard } from '@/types/insight';
import { Poll } from '@/types/poll';
import { 
  Select, 
  SelectContent, 
  SelectGroup, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from '@/components/ui/select';

interface CardSelectorProps {
  availableCards: InsightCard[];
  selectedCardId: string;
  setSelectedCardId: (id: string) => void;
  isLoading: boolean;
  poll: Poll | null;
}

const CardSelector: React.FC<CardSelectorProps> = ({ 
  availableCards, 
  selectedCardId, 
  setSelectedCardId,
  isLoading,
  poll
}) => {
  if (isLoading) {
    return <div className="text-foreground">Loading cards...</div>;
  }
  
  if (availableCards.length === 0) {
    return (
      <div className="text-amber-600 dark:text-amber-400 text-sm">
        No insight cards available. Please create an insight card first.
      </div>
    );
  }
  
  return (
    <Select 
      value={selectedCardId} 
      onValueChange={setSelectedCardId}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Choose an insight card" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {availableCards.map((card) => (
            <SelectItem key={card.id} value={card.id.toString()}>
              {card.title} ({card.category})
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default CardSelector;
